window.dtScheduleGroup = function () {
  const dt_schedule_group = new DataTable('#schedule-group-datatable', {
    processing: false,
    serverSide: true,
    responsive: true,
    ajax: {
      url: $('#schedule-group-datatable').data('source'),
      beforeSend: function () { showLoadingRow('#schedule-group-datatable', 3); },
      complete: function () { hideLoadingRow(); }
    },
    pagingType: "full_numbers",
    order: [[1, 'asc']],
    columns: [
      { "data": "index" },
      { "data": "status" },
      { "data": "name" },
    ],
    columnDefs: [
    ],
    language: {
      search: ' ',
      sLengthMenu: '_MENU_',
      searchPlaceholder: "Search...",
      info: "Showing _START_ to _END_ of _TOTAL_ entries"
    },
    rowCallback: function (row, data, index) {
      $('td', row).addClass('py-1');
    },
  });

  dtFinalTouch()
}